import { render, staticRenderFns } from "./TableCard.vue?vue&type=template&id=216e78ce&scoped=true"
import script from "./TableCard.vue?vue&type=script&lang=js"
export * from "./TableCard.vue?vue&type=script&lang=js"
import style0 from "./TableCard.vue?vue&type=style&index=0&id=216e78ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216e78ce",
  null
  
)

export default component.exports